import apiHandler from "../core/apiHandler";

const incotermApi = apiHandler('incoterms');

export default incotermApi;
